export enum PCHAlertServiceMessageType {
    SetNextReminder = 'SET_NEXT_REMINDER',
    CancelNextReminder = 'CANCEL_NEXT_REMINDER',
    ReminderFired = 'REMINDER_FIRED',
}
